module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/279e5c05c69bcd19f76b9ca86bfa7ec5.gif";